module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/dane-rejestracyjne-057936e6.png";